// src/components/LogoutButton.tsx
import React from "react";
import { logoutUser } from "../api/client";
import { useUserSession } from "../context/useUserSession";

interface LogoutButtonProps {
  className?: string;
}

export const LogoutButton: React.FC<LogoutButtonProps> = ({ className }) => {
  const { setUser, setDevices } = useUserSession();

  const handleClick = async () => {
    try {
      await logoutUser();
      setUser(null);
      setDevices([]);
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    } catch (err) {
      console.error("Logout failed:", err);
      alert("Logout failed. Please try again.");
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`
        ${className ?? ""}
        px-3 py-1 text-sm rounded-md
        bg-gray-100 text-gray-800
        hover:bg-gray-200
        focus:outline-none focus:ring-2 focus:ring-gray-300
        transition-colors duration-150
      `}
    >
      Logout
    </button>
  );
};
